module.exports = __webpack_public_path__ + "fonts/icon-original.4d286a7.eot";